


































import mixin from 'vue-typed-mixins';
import { toastMixin } from '@/Shared/CommonEntityMixins/ToastMixin';
import ValidationErrorDirective, { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { Dictionary } from 'vue-router/types/router';
import { Location } from '@/Stores/UserStore';

const LoginPage = mixin(toastMixin).extend({
    data() {
        return {
            userId: '',
            password: '',
            validationErrors: {} as Dictionary<string[]>,
            errorMessage: null as string | null,
        };
    },
    directives: {
        ValidationErrorDirective
    },
    methods: {
        async submit() {
            this.validationErrors = {};
            this.errorMessage = null;
            try {
                const returnAfterLogin = {...this.$typedStore.modules.userModule.state.returnAfterLogin};

                const user = await this.$typedStore.modules.userModule.actions.login({
                    userId: this.userId,
                    password: this.password
                });

                const locations = await this.$typedStore.modules.userModule.actions.getAllowedLocations();
                const pending = this.$typedStore.getters.pendingNavigation;
                let location: Location | undefined;

                if (!returnAfterLogin.name) {
                    if (user.defaultLocation && pending?.name === 'vatsLogin') {
                        location = locations.find(item => item.urlSegment === user.defaultLocation);

                        if (location) {
                            await this.$router.push({
                                name: 'locationHome',
                                params: {['location']: location.urlSegment}
                            });
                        }
                    } else if (pending?.params.location) {
                        location = locations.find(item => item.urlSegment === pending.params.location);
                    }
                } else {
                    location = locations.find(item => item.urlSegment === returnAfterLogin.params?.location);
                }

                if (location) {
                    this.$typedStore.actions.getMenuItems(location);
                }
            } catch (e) {

                let title: string;
                let message: string;

                if (e.response.status === 403) {
                    // forbidden
                    title = 'login.loginForbiddenTitle';
                    message = 'login.loginForbiddenMessage';
                } else if (e.response.status === 409) {
                    // conflict
                    title = 'passwordResetRequest.submitText';
                    message = 'passwordResetRequest.requestSuccessMessage';
                }
                else if (e.response.status === 429) {
                    // too many requests
                    title = 'login.tooManyRequestsTitle';
                    message = e.response.data;
                }
                else if (!e.response || e.response.status !== 400 || !e.response.data) {
                    // not 400 -- not bad request
                    title = 'login.loginFailedTitle';
                    message = 'login.loginFailedMessage';

                } else {
                    // something else
                    this.validationErrors = getValidationErrors(e.response);
                    return;
                }

                this.errorMessage = this.$t(message).toString();
                this.popupToast(title, message);
                return;
            }
        },
    },
});

export default LoginPage;
